import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const Swimming = () => {
  const [activeImage, setActiveImage] = useState(0);

  const sectionData = {
    name: 'Swimming ',
    category: 'Aquatic Sports',
    description: 'Competitive swimming and water sports programs.',
    longDescription: 'Dive into excellence with our Swimming Club. From learn-to-swim programs to competitive training, we offer comprehensive aquatic programs for all ages. Our Olympic-size pool, experienced coaches, and supportive community help swimmers achieve their goals, whether for fitness, fun, or competition.',
    images: [
      getImagePath('images/bars/swimming.jpg'),
      getImagePath('images/bars/swimming.jpg'),
      getImagePath('images/bars/swimming.jpg')
    ],
    icon: 'fa-swimmer',
    members: '78+ active members',
    coach: 'Olympic Coach Sarah Adeyemi',
    schedule: 'Mon-Fri: 6am-8am, 4pm-7pm | Sat: 8am-12pm',
    level: 'All Levels',
    features: [
      'Learn to Swim',
      'Competitive Training',
      'Masters Swimming',
      'Water Polo',
      'Synchronized Swimming',
      'Aqua Fitness',
      'Stroke Clinics',
      'Swim Meets'
    ],
    facilities: ['Olympic Pool', 'Kids Pool', 'Training Equipment', 'Bleachers'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'swim@nlngraclub.com',
      extension: '213'
    },
    groups: ['Tiny Tots (3-5)', 'Age Group (6-12)', 'Juniors (13-17)', 'Seniors', 'Masters'],
    meets: ['Club Championships', 'Inter-club Meets', 'Time Trials']
  };

  return (
    <div className="section-detail-page">
      {/* Hero Section */}
      <section className="section-detail-hero">
        <div className="hero-background">
          <img src={sectionData.images[0]} alt={sectionData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/sections" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Sections
            </Link>
            <span className="section-category">{sectionData.category}</span>
            <h1 className="section-title">{sectionData.name}</h1>
            <p className="section-subtitle">{sectionData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Section Content */}
      <section className="section-content-section">
        <div className="container">
          <div className="section-grid">
            {/* Left Column - Images */}
            <div className="section-gallery">
              <div className="main-image">
                <img 
                  src={sectionData.images[activeImage]} 
                  alt={sectionData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {sectionData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${sectionData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="section-details">
              <div className="detail-section">
                <h2>About {sectionData.name}</h2>
                <p className="section-description">{sectionData.longDescription}</p>
              </div>

              <div className="coach-info">
                <div className="info-card">
                  <i className="fas fa-user-tie"></i>
                  <div>
                    <h4>Head Coach</h4>
                    <p>{sectionData.coach}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <div>
                    <h4>Members</h4>
                    <p>{sectionData.members}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <div>
                    <h4>Pool Hours</h4>
                    <p>{sectionData.schedule}</p>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {sectionData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Age Groups:</span>
                  <span className="info-value">{sectionData.groups.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Competitions:</span>
                  <span className="info-value">{sectionData.meets.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-handshake"></i> Join This Section
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-calendar"></i> Swim Assessment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Swimming;